
<ul class="tabs-container">
  <li v-for="tab in displayedTabs" class='tab' :class="{current: isCurrentTab(tab.index)}" :key="`tab-${tab.index}`" @click="setCurrentTab(tab)">
    <button type="button" v-tooltip="tab.name.length > 19 ? tab.name : ''">
      <!--          If there is no name use the index for the name, truncate longer names-->
      {{(tab.name || `Tab ${tab.index+1}`).replace(/(.{19})..+/, "$1&hellip;") }}
    </button>
  </li>

  <li class="dropdown tab" v-if="displayShowMoreTab">
    <button class="tab-toggle" type="button" id="moreTabsDropDown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      More
    </button>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="moreTabsDropDown">
      <button v-for="tab in additionalTabs" class="dropdown-item" @click="setCurrentTabFromAdditionalTabs(tab)" type="button">
        {{tab.name || `Tab ${tab.index+1}`}}
      </button>
    </div>
  </li>
</ul>
